/**
 * A utility class to log messages to the console.
 * This class supports logging different types of messages such as `info`, `warn` and `error`.
 *
 * @class Logger
 */
class Logger {
  private static defaultStyles: Record<string, string> = {
    info: 'color: #3498db; font-weight: bold',
    warn: 'color: #fdcb6e; font-weight: bold',
    error: 'color: #ff7675; font-weight: bold'
  }

  static log(
    message: string,
    payload?: object,
    level: keyof typeof Logger.defaultStyles = 'info'
  ): void {
    const style = Logger.defaultStyles[level] || Logger.defaultStyles.info

    if (payload && typeof payload === 'object') {
      // eslint-disable-next-line no-console
      console.log(`[HotClubHttp][${message}]`, payload)

      return
    }

    // eslint-disable-next-line no-console
    console.log(`%c${message}`, style)
  }

  static info(message: string, payload?: object): void {
    this.log(message, payload, 'info')
  }

  static warn(message: string, payload?: object): void {
    this.log(message, payload, 'warn')
  }

  static error(message: string, payload?: object): void {
    this.log(message, payload, 'error')
  }
}

export default Logger
